import axios from 'axios';
import React, {
  Component,
} from 'react';

// var buffer = require('buffer');
import buffer from 'buffer';

var api = require('../Common/Config');

class Authservice extends React.Component{

  constructor(){
    super()
    this.state = {          
      Token : null,
      FACode: null,  
    };
  }

  componentWillMount() {
    sessionStorage.getItem("tokenData").then(value => {

      var state = JSON.parse(value);
      this.setState({
        FACode: state.accesstoken?state.accesstoken:'',
      });
    });
  }

  async login(creds,cb){
    var self = this;
/*
Used buffer for encrypt userName and passWord
using base64 function
*/
    var b = new buffer.Buffer(creds.username+':'+creds.password) ;
    var Auth = b.toString('base64');

  //  console.log(Auth);

    var details = {
      'username': creds.username.trim().toLowerCase(),
      'password': creds.password,
      'grant_type': 'password'
    };

          var formBody = [];
          for (var property in details) {
            var encodedKey = encodeURIComponent(property);
            var encodedValue = encodeURIComponent(details[property]);
            formBody.push(encodedKey + "=" + encodedValue);
          }
          formBody = formBody.join("&");
          
          await axios({
            method: 'post',
            url: api.HOST+'oauth/token',
            data: formBody,
            headers: {
              'Authorization' : 'Basic dHJ1c3RlZC1jbGllbnQ6c2VjcmV0',
              'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
            },        
          }).then((responses)=>{
          if(responses.status >= 200 && responses.status<300){
            //self._setAuthData(responses.headers);
            return responses;
          }else{
            if(responses.response.status == 400){
              return 400;
            }else if(responses.response.status == 401){
              return 401;
            }
          }       
        })        
        .then((results)=>{    
           if(results.data != undefined){
              self._setToken(results.data);         
              return cb({success:true})
           }else{
              return cb(results);
           }
          })       
          .catch ((err)=>{
             console.log('Login Fail : ' +err)
          // this.status(err);
            return cb (err.response?err.response.status:err);
            console.log("errr  : status : "+err.response.status);

          })
        .finally(()=>{
            //this.setState({showProgress:false});
          });
  }


  _setToken(headers) {
    var h = headers;
    var tokendata = {
      accesstoken: h.access_token,
      tokentype: h.token_type,
      represhtoken: h.refresh_token,
      tokenExpiry: h.expires_in,
      scope:h.scope
    }
    var value = JSON.stringify(tokendata);
    sessionStorage.setItem('tokenData', value );
  }

  async getAuthData(){
    return await sessionStorage.getItem('authData').then(dataString => JSON.parse(dataString));
  }

  async getTokenData(){
    return await sessionStorage.getItem('tokenData').then(dataString => JSON.parse(dataString));
  }

  logout(){
    var logOutData = {
      providerKey: '',
      ownerKey: '',
      token: '',
      tokenExpiry:''
    }

    sessionStorage.setItem('logOutData', JSON.stringify(logOutData));
    //TODO: further logic
  }
}

export default Authservice
